/**
 * The moments a guided shot reveals, and how a click inside the shot asks
 * for one. Kept apart from the interactive shot so the island that loads it
 * can remember a click made before it arrives.
 */
export type GuidedMoment = { kind: "record"; recordId: string } | { kind: "trace" };

/** The moment a click on `target` asks for: a record link opens its record,
 *  the run trace pill opens the trace. */
export function guidedMomentFor(target: EventTarget | null): GuidedMoment | null {
  if (!(target instanceof Element)) return null;
  const link = target.closest<HTMLAnchorElement>("a[href*='?record=']");
  if (link) {
    const recordId = new URL(link.getAttribute("href") ?? "", "https://mlx.systems").searchParams.get("record");
    if (recordId) return { kind: "record", recordId };
  }
  if (target.closest(".mlx-run-trace-pill")) return { kind: "trace" };
  return null;
}
